import React from "react";
import Image from "next/image";
import Section from "@/components/ui/section";

export default function ReportHero() {
  return (
    <Section
      variant="flatZero"
      className="bg-[#F4F9FF] pt-[120px] md:pt-[120px] pb-16 lg:min-h-[calc(100vh-100px)] justify-center"
    >
      <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-[72px]">
        {/* Left: report copy */}
        <div className="flex flex-col">
          <p className="md:mb-5 mb-3 text-xs font-bold uppercase tracking-[0.14em] text-blue">
            Regional report · South and Southeast Asia
          </p>
          <h1 className="font-semibold text-darkBlue">On Their Own Terms</h1>
          <p className="md:mb-7 mb-4 md:mt-3 text-xl font-medium leading-snug text-darkBlue/90 md:text-[26px]">
            Survivors&rsquo; Idea of Dignity and Justice
          </p>
          <p className="mb-4 max-w-[34em] text-sm leading-relaxed text-darkGrey md:text-lg">
            168 survivors of sexual violence, 160 family members, and 192
            justice system actors, caseworkers and community workers across
            Bangladesh, India, Indonesia, Nepal, the Philippines and Sri Lanka
            say what justice means to them, what helped them seek it, and what
            made it harder.
          </p>
          <p className="max-w-[34em] text-sm leading-relaxed text-darkGrey md:text-lg">
            Justice is more than reporting or conviction. It is safety, dignity,
            healing, financial security, reproductive choice, and the support to
            rebuild a life. This report sets out seven recommendations for a
            survivor-centric system that is both responsive and accountable.
          </p>
        </div>

        {/* Right: report cover card + download */}
        <div className="lg:mx-auto md:max-w-[400px] flex lg:w-full max-w-[460px] flex-col items-stretch">
          <div className="flex aspect-[1000/1414] w-full flex-col overflow-hidden bg-darkBlue shadow-[0_24px_48px_rgba(45,39,106,0.22)]">
            <div className="relative min-h-0 w-full flex-1">
              <Image
                src="/images/on-their-own-terms-cover.webp"
                alt="A young woman cycles past a mural of three men on bicycles"
                fill
                className="object-cover object-[35%_50%]"
                sizes="(max-width: 1024px) 100vw, 460px"
              />
            </div>
          </div>

          <a
            href="/pdf/OnTheirOwnTerms.pdf"
            target="_blank"
            rel="noopener"
            className="flex min-h-[44px] items-center justify-between gap-4 bg-darkBlue px-6 py-[18px] text-[17px] font-semibold text-white no-underline transition-colors duration-200 hover:bg-[#1f1b52]"
          >
            <span>Download the report</span>
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M12 4v11" />
              <path d="M7 11l5 5 5-5" />
              <path d="M5 20h14" />
            </svg>
          </a>
        </div>
      </div>
    </Section>
  );
}
